enum QueueStatusEnum {
    NOT_STARTED = 1,
    PROCESSING = 2,
    COMPLETED = 3,
    ERRORED = 4,
    EMAILED = 5,
}

export default QueueStatusEnum;
